export const isValidPhoneNumber = (phone) => {
  if (!phone) return false;

  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');

  // Valid Mexican number: starts with '52' and 12 digits total (52 + 10 digits)
  const isMexican = cleaned.startsWith('52') && cleaned.length === 12;

  // Valid US number:
  // 1. Starts with '1' and has 11 digits (1 + 10-digit number)
  // 2. Or exactly 10 digits (US number without country code)
  const isUS = (cleaned.startsWith('1') && cleaned.length === 11) || cleaned.length === 10;

  return isMexican || isUS;
};

export const campaignDoesNotBelongToCompany = (error) => {
  const unauthorizedStatus = error
    && error.response
    && error.response.status === 403;
  const unauthorizedMessage = error
    && error.response
    && error.response.data
    && error.response.data.message
    && error.response.data.message.includes('does not own campaign');
  return unauthorizedStatus && unauthorizedMessage;
};
